import React from "react";

const socialLinks = [
  {
    href: "https://www.facebook.com/42courses",
    label: "42courses on Facebook",
    path: "M14 9h3V6h-3c-2 0-3 1-3 3v2H9v3h2v6h3v-6h2.5l.5-3H14V9z",
  },
  {
    href: "https://x.com/42courses",
    label: "42courses on X",
    path: "M4 4l7 9-7 7h2l6-6 5 6h4l-8-10 7-6h-2l-5 5-4-5H4z",
  },
  {
    href: "https://www.linkedin.com/company/42courses",
    label: "42courses on LinkedIn",
    path: "M6 9v9H3V9h3zM4.5 4a1.7 1.7 0 1 1 0 3.4 1.7 1.7 0 0 1 0-3.4zM9 9h3v1.3c.5-.8 1.5-1.5 3-1.5 2.5 0 4 1.6 4 4.6V18h-3v-4.2c0-1.2-.5-2-1.6-2S15 12.7 15 13.9V18h-3V9z",
  },
  {
    href: "https://www.instagram.com/42courses/",
    label: "42courses on Instagram",
    path: "M7 3h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4zm5 5a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm0 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm5-3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2z",
  },
];

const LessonFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="l-footer dark-context" aria-label="Footer">
      <div className="l-footer__inner">
        <div className="l-footer__tag">Make yourself irreplaceable</div>
        <div className="l-footer__connect">
          <span className="lbl">Connect with us</span>
          {socialLinks.map(({ href, label, path }) => (
            <a href={href} aria-label={label} rel="noopener" key={label}>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d={path}></path>
              </svg>
            </a>
          ))}
        </div>
      </div>
      <div className="l-footer__bottom">
        <a href="mailto:info@42courses.com">info@42courses.com</a>
        <span>
          <a href="/privacy">Privacy Policy</a>
        </span>
        <span>&copy; 2015 to {currentYear} 42courses.com Ltd.</span>
      </div>
    </footer>
  );
};

export default LessonFooter;
